<template>
  <div id="app">
    <h4><small> {{ title }} </small></h4>
    <highcharts :options="chartOptions" ref='chart'></highcharts>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import Vue from 'vue'
import axios from 'axios';
import mixin from '../../../../utils/mixin'

export default {
  name: 'execution-chart',
  props: {
    title: {
      type: String
    },
    id: {
      type: String
    },
    data: {
      type: Array,
    },
    filters: {
      type: Object
    },
    online:{
        type: Number,
        default: 0
    }
  },
  data () {
    return {
      tableData: [],
      type: 'line',
      chartOptions: {
        colors: ['#90ed7d', '#f45b5b'],
        chart: {
          type: 'line',
          backgroundColor: 'rgba(0,0,0,0)',
          style: {
            fontFamily: '\'Unica One\', sans-serif'
          },
          plotBorderColor: '#606063'
        },
        title: {
            text: '',
            style: {
                color: '#fff',
                textTransform: 'uppercase',
                fontSize: '16px',
                fontWeight: 'bold'
            }
        },
        subtitle: {
            style: {
                color: '#E0E0E3',
                textTransform: 'uppercase'
            }
        },
        xAxis: {
            categories: [this.$t("303"), this.$t("304")],
            crosshair: true,
            gridLineColor: '#707073',
            labels: {
                style: {
                    color: '#fff'
                }
            },
            lineColor: '#707073',
            minorGridLineColor: '#505053',
            tickColor: '#707073',
            title: {
                text: '',
                style: {
                    color: '#A0A0A3',
                }
            }
        },
        yAxis: {
            min: 0,
            title: {
                text: this.$t("131"),
                style: {
                    color: '#A0A0A3',
                    fontSize: '12px',
                }
            },
            gridLineColor: '#707073',
            labels: {
                style: {
                    color: '#E0E0E3'
                }
            },
            lineColor: '#707073',
            minorGridLineColor: '#505053',
            tickColor: '#707073',
            tickWidth: 1,
        },
        tooltip: {
            backgroundColor: 'rgba(0, 0, 0, 0.85)',
            style: {
                color: '#F0F0F0'
            },
            headerFormat: '<span style="font-size:10px">{point.key} days</span><table>',
            pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                '<td style="padding:0"><b> {point.y} </b></td></tr>',
            footerFormat: '</table>',
            shared: true,
            useHTML: true
        },
        plotOptions: {
            series: {
                dataLabels: {
                    enabled: true,
                    color: '#F0F0F3',
                    style: {
                        fontSize: '13px'
                    }
                },
                marker: {
                    lineColor: '#333'
                },
                events:{
                    click: this.loadGrid
                },
                cursor: 'pointer'
            },
            boxplot: {
                fillColor: '#505053'
            },
            candlestick: {
                lineColor: 'white'
            },
            errorbar: {
                color: 'white'
            },
            column: {
                pointPadding: 0.1,
                borderWidth: 0
            }
        },
        legend: {
            enabled: false
        },
        labels: {
            style: {
                color: '#fff'
            }
        },
        drilldown: {
            activeAxisLabelStyle: {
                color: '#F0F0F3'
            },
            activeDataLabelStyle: {
                color: '#F0F0F3'
            }
        },
        navigation: {
            buttonOptions: {
                symbolStroke: '#DDDDDD',
                theme: {
                    fill: '#505053'
                }
            }
        },
        rangeSelector: {
            buttonTheme: {
                fill: '#505053',
                stroke: '#000000',
                style: {
                    color: '#CCC'
                },
                states: {
                    hover: {
                        fill: '#707073',
                        stroke: '#000000',
                        style: {
                            color: 'white'
                        }
                    },
                    select: {
                        fill: '#000003',
                        stroke: '#000000',
                        style: {
                            color: 'white'
                        }
                    }
                }
            },
            inputBoxBorderColor: '#505053',
            inputStyle: {
                backgroundColor: '#333',
                color: 'silver'
            },
            labelStyle: {
                color: 'silver'
            }
        },
        navigator: {
            handles: {
                backgroundColor: '#666',
                borderColor: '#AAA'
            },
            outlineColor: '#CCC',
            maskFill: 'rgba(255,255,255,0.1)',
            series: {
                color: '#7798BF',
                lineColor: '#A6C7ED'
            },
            xAxis: {
                gridLineColor: '#505053'
            }
        },
        scrollbar: {
            barBackgroundColor: '#808083',
            barBorderColor: '#808083',
            buttonArrowColor: '#CCC',
            buttonBackgroundColor: '#606063',
            buttonBorderColor: '#606063',
            rifleColor: '#FFF',
            trackBackgroundColor: '#404043',
            trackBorderColor: '#404043'
        },
        series: [{
            name: this.$t("300"),
            type: 'column',
            data: this.data,
            colorByPoint: true
        }],
        exporting: { enabled: false },
        credits: {
          enabled: false
        },
        loading: {
            labelStyle: {
                color: 'black',
                textShadow: '1px 0 0 #fff, -1px 0 0 #fff, 0 1px 0 #fff, 0 -1px 0 #fff, 1px 1px #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff',
            },
            style: {
                backgroundColor: 'none',
                opacity: 1,
            }
        },
      },
    }
  },
  mixins: [mixin],
  methods: {
    ...mapMutations(['changeGrid']),

    loadGrid(event){

        if(event.point.y != 0){
            let area_id = '';
            let planta = ''; 
            let region = '';

            if (this.filters.plant){
                planta = this.filters.plant;
                area_id = this.id;
            } else if (this.filters.region){
                planta = this.id;
            } else {
                region = this.id;
            }

            let NAME_CHART = this.$t("358")

            let delay = event.point.x;

            delay = delay == 1 ? 4 : delay;

            const ENDPOINT = `v1/mysemeq-ambev/get-reports-repetition?year=${this.filters.year}&period=${this.filters.period}&plant=${planta}&region=${region}&technique=${this.online ? '' : this.filters.technique}&area=${this.filters.area}&sector=${this.filters.sector}&machine=${this.filters.machine}&component=${this.filters.component}&feedback_status=CLOSED&area_id=${area_id}&online=${this.online}&delay=${delay}`

            let grid = {
                totalDados: event.point.y,
                title: this.$t("358") + ' - ' + this.title,
                url: ENDPOINT,
                name_chart: NAME_CHART,
                columns: {
                    "rows": '',
                    "plant": this.$t("310"),
                    "area": this.$t("311"),
                    "sector": this.$t("312"),
                    "component": this.$t("313"),
                    "component_tag": this.$t("314"),
                    "component_type_en": this.$t("315"),
                    "machine": this.$t("316"),
                    "machine_tag": this.$t("317"),
                    "technique_en": this.$t("321"),
                    "report_number": this.$t("319"), 
                    "approved_datetime": this.$t("320"),
                    "link": this.$t("323"),
                    "link_rci": this.$t("324"),
                    "pending_days": this.$t("325"),
                    "delay": this.$t("326"),
                    "prescription_created_datePtime": this.$t("327"), 
                    "week": this.$t("328"),
                    },
                show: true,
                titleHelp: 'Grid - ' + this.$t("358"),
                txtHelp: this.$t("357")
            }

            this.changeGrid(grid);
        }  

    },
  },
  watch: {
    data: function(value) {
        this.$refs.chart.chart.redraw();
    }
  },
  mounted() {
    // if (this.soma <= 0)
    //   this.$refs.chart.chart.showLoading('No data!');
  }
}
</script>
<style scoped>
tspan {
  stroke: none!important;
  stroke-width: 1px;
  stroke-linejoin: round;
}
.highcharts-drilldown-data-label text{
  text-decoration:none !important;
}

h4 small{
  color: #ffffff;
  text-align: center;
  display: block;
  padding-top: 8px
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Charts/ExecutionChartTotal.vue